/* Change this file to get your personal Portfolio */

// Your Summary And Greeting Section

import emoji from "react-easy-emoji";

const greeting = {
  /* Your Summary And Greeting Section */
  username: "Octavio Pareja",
  title: "Hola a todos, soy Octa",
  subTitle: emoji(
    "Soy desarrollador front-end (y diseñador gráfico de profesión) 🚀 con +13 años de experiencia en maquetado de sitios web, incluyendo desarrollo en HTML+CSS3+JS, React JS, React Native, y mucho más."
  ),
  resumeLink: "https://www.linkedin.com/in/octapareja/",
};

// Your Social Media Link

const socialMediaLinks = {
  github: "https://github.com/octaviopareja",
  linkedin: "https://www.linkedin.com/in/octapareja/",
  gmail: "contacto@octaviopareja.com",
  // Instagram and Twitter are also supported in the links!
};

// Your Skills Section

const skillsSection = {
  title: "¿Que hago?",
  subTitle: "Soy maquetador pixel perfect & front-end developer",
  skills: [
    emoji("⚡ Desarrollo aplicaciones y interfaces optimizadas y pensadas para el usuario. "),
    emoji("⚡ Tengo el ojo crítico como diseñador aplicado al desarrollo de apps.)"),
    emoji("⚡ Experto en HTML+CSS y Front-end. SPA & Progressive Web Applications ( PWA )."),
    emoji("⚡ React JS & React Native Main "),
    emoji("⚡ Administro servidores web, creo el sitio, levanto servicios, y todo funcionando!"),
  ],

  /* Make Sure You include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5",
    },
    {
      skillName: "bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap",
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt",
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass",
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js",
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "react-native",
      fontAwesomeClassname: "fab fa-react",
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm",
    },
    {
      skillName: "mysql-database",
      fontAwesomeClassname: "fas fa-database",
    },
    {
      skillName: "php",
      fontAwesomeClassname: "fas fa-code",
    },
    {
      skillName: "web-servers",
      fontAwesomeClassname: "fas fa-server",
    },
    {
      skillName: "adobe XD",
      fontAwesomeClassname: "fab fa-adobe",
    },
    {
      skillName: "figma",
      fontAwesomeClassname: "fab fa-figma",
    },
  ],
};

// Your education background

const educationInfo = {
  viewEducation: true, // Set it to true to see education section
  schools: [
    {
      schoolName: "Universidad Blas Pascal",
      logo: require("./assets/images/ubp-logo.png"),
      subHeader: "Técnico Universitario en Diseño Gráfico",
      duration: "2006 - 2012",
      desc: "",
      descBullets: [],
    },
    {
      schoolName: "CoderHouse",
      logo: require("./assets/images/coderhouselogo.png"),
      subHeader: "React JS",
      duration: "2020",
      desc: "",
      descBullets: [],
    },
    {
      schoolName: "CoderHouse",
      logo: require("./assets/images/coderhouselogo.png"),
      subHeader: "Javascript",
      duration: "2020",
      desc: "",
      descBullets: [],
    },
    {
      schoolName: "CoderHouse",
      logo: require("./assets/images/coderhouselogo.png"),
      subHeader: "React Native",
      duration: "2021",
      desc: "",
      descBullets: [],
    },
  ],
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "100%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Maquetado / Layout Design / CSS3 / Bootstrap",
      progressPercentage: "100%",
    },
    {
      Stack: "Frontend / JS / React",
      progressPercentage: "100%",
    },
    {
      Stack: "React Native",
      progressPercentage: "100%",
    },
    {
      Stack: "GitHub - Branching - CI/CD",
      progressPercentage: "100%",
    },
  ],
};

// Your top 3 work experiences

const workExperiences = {
  viewExperiences: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Desarrollador Full Stack",
      company: "Grupo Montironi",
      companylogo: require("./assets/images/montironilogo.png"),
      date: "Desde Febrero 2020",
      desc: "Desarrollo/programación de soluciones digitales para el área de Marketing Digital. CSS3, SASS, HTML5, JS, JQuery PHP, WordPress, Bootstrap, entre otros. Gestion de proyectos: Trello.",
      descBullets: [
        "HTML5, React JS, Native, JQuery, PHP, WordPress, Bootstrap, Github-GitLab CI/CD entre otros. Gestion de proyectos: Trello, Jira, Asana.",
        "Tools: Zeplin, Figma, Adobe XD, Notion.io",
      ],
    },
    {
      role: "Desarrollador Front-End | Maquetador web",
      company: "Avra Dev",
      companylogo: require("./assets/images/avradevlogo.png"),
      date: "Desde Febrero 2017",
      desc: "Desarrollos Front-End - Maquetado Web - Consultoría",
      descBullets: [
        "HTML5, React JS, Native, JQuery, PHP, WordPress, Bootstrap, Github-GitLab CI/CD entre otros. Gestion de proyectos: Jira, Asana.",
        "Tools: Zeplin, Figma, Adobe XD, Notion.io, Jira, GitHub",
      ],
    },
    {
      role: "Desarrollador Front-End | Maquetador web",
      company: "Fryla",
      companylogo: require("./assets/images/frylastudio.jpg"),
      date: "Desde Febrero 2017",
      desc: "Maquetador y desarrollador Web, desde el año 2017 de manera freelance. Sitio Web: www.fryla.com.ar",
      descBullets: [
        "HTML5, React JS,, CSS3, SASS, PHP, Wordpress (Avada). Gestión de proyectos: Asana.",
        "Tools: Zeplin, Figma, Adobe XD, Notion.io, Jira, GitHub",
      ],
    },
    {
      role: "Desarrollador Front-End | Maquetador web",
      company: "Ubicuo",
      companylogo: require("./assets/images/ubicuologo.png"),
      date: "Desde Diciembre 2019",
      desc: "Desarrollos de Front-End a distintos proyectos dentro de Ubicuo.",
    },
    {
      role: "Community Manager | Diseñador Gráfico",
      company: "Tecnomyl Argentina",
      companylogo: require("./assets/images/tecnomyllogo.jpg"),
      date: "Desde Septiembre 2019",
      desc: "Community Manager, desarollo de presencia digital desde cero. Diseño de flyers comerciales digitales, comunicación interna/externa. Mailings. Newsletters.",
    },
    {
      role: "Community Manager | Diseñador Gráfico",
      company: "Grupo Agroempresa",
      companylogo: require("./assets/images/agroempresalogo.jpg"),
      date: "Julio 2017 - Enero 2020",
      desc: "Community Manager del grupo (Incluyendo a todas las unidades de negocio del grupo: Aktiv, ArgenBean, Agroempresa Colón, Agrompresa Semillias, Agroempresa Máquinas Agrícolas, y Agromáquinas Sinscate. ",
    },
    {
      role: "Community Manager | Diseñador Gráfico",
      company: "Bodega Terra Camiare",
      companylogo: require("./assets/images/terracamiarelogo.png"),
      date: "Julio 2017 - Enero 2020",
      desc: "Desarrollo de presencia digital de Bodega Terra Camiare, Córdoba, Argentina. ",
    },
    {
      role: "Seemple Studio | Diseñador Gráfico",
      company: "Seemple Studio",
      companylogo: require("./assets/images/semplelogo.jpg"),
      date: "Marzo 2011 - Diciembre 2018",
      desc: "Maquetador y desarrollador Web, desde el año 2011 de manera freelance. Sitio Web: www.seemple.com.ar",
    },
    {
      role: "Co-Founder",
      company: "Ipxon Networks",
      companylogo: require("./assets/images/ipxonlogo.png"),
      date: "Marzo 2011 - Marzo 2018",
      desc: "Co-Founder año 2004 a 2018. Comenzo como un proyecto durante mi adolescencia junto a mi Socio. Trabajé en todas las áreas de la empresa. Comenzo como un pequeño proyecto que fue escalando. Participe en la fundación del emprendimiento. Duraten mi participación, me movi por todas las áreas: Administración, soporte técnico, atención al público, desarrollo web, gráfica, marketing digital, CRM, y mucho más. ",
    },
    {
      role: "Co-Founder",
      company: "CordobaHost",
      companylogo: require("./assets/images/cbahostlogo.jpg"),
      date: "Marzo 2004 - Marzo 2011",
      desc: "Co-Founder año 2004 a 2018. Comenzo como un proyecto durante mi adolescencia junto a mi Socio. Trabajé en todas las áreas de la empresa. Comenzo como un pequeño proyecto que fue escalando. Participe en la fundación del emprendimiento. Duraten mi participación, me movi por todas las áreas: Administración, soporte técnico, atención al público, desarrollo web, gráfica, marketing digital, CRM, y mucho más.  ",
    },
  ],
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: "",
  githubUserName: "https://github.com/octaviopareja/", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to false
};

// Some Big Projects You have worked with your company

const bigProjects = {
  title: "",
  subtitle: "",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      link: "",
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      link: "",
    },
  ],
};

// Your Achievement Section Include Your Certification Talks and More

const achievementSection = {
  title: emoji("Logros 🏆 "),
  subtitle: "Estudios realizados",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing",
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing",
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html",
        },
      ],
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en",
        },
      ],
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      footerLink: [
        { name: "Certification", url: "" },
        { name: "Final Project", url: "https://pakistan-olx-1.firebaseapp.com/" },
      ],
    },
  ],
};

// Blogs Section

const blogSection = {};

// Talks Sections

const talkSection = {};

// Podcast Section

const podcastSection = {};

const contactInfo = {
  title: emoji("Hablemos ☎️"),
  subtitle: "¡Enviame tu correo y con gusto me comunico!",
  number: "octaviopareja05@gmail.com",
  email_address: "octaviopareja05@gmail.com",
};

//Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
};
export {
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
};
